import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion';
import Header from '../components/Header';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from '../components/Footer';
import LogoComponent from '../components/LogoComponent';
import MobileMenu from '../components/MobileMenu';
import ScrollProgress from '../components/ScrollProgress';
const PageContainer = () => {

  const location = useLocation();
  const [toggle, setToggle] = useState(false);


  useEffect(() => {
    // Scroll to top whenever the location changes
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const pageVariants = {
    initial: {
      translateY: -30,
      scale: 0.95,
      opacity: 0,
    },
    in: {
      translateY: 0,
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.8, // opacity geçişi daha yavaş ve yumuşak
        ease: [0.25, 0.1, 0.25, 1], // daha yumuşak easing
      },
    },
    out: {
      translateY: 30,
      scale: 1,
      opacity: 0,
      transition: {
        duration: 0.6, // çıkış animasyonu biraz daha hızlı olabilir
        ease: [0.25, 0.1, 0.25, 1],
      },
    }
  };

  const pageTransition = {
    type: 'spring',
    stiffness: 100,
    damping: 25,
    mass: 0.8,
    duration: 1.5, // geçiş süresini artırarak daha yumuşak bir etki elde ediyoruz
    ease: [0.25, 0.1, 0.25, 1], // daha yumuşak bir easing eğrisi
  };



  return (
    <div className='flex flex-col'>
      <ScrollProgress />

      <LogoComponent toggle={toggle} setToggle={setToggle} />
      <motion.div key={location.pathname}
      >
        <div className={`fixed h-screen  w-full z-40 bg-white  pt-20 ${toggle ? 'block' : 'hidden'} `} toggle={toggle} setToggle={setToggle}>
          <MobileMenu />

        </div>




        <div className='grid grid-cols-10'>
          {/* <Header toggle={toggle} setToggle={setToggle} /> */}
          <div className='col-span-10  flex-none  '>

            <motion.div
              initial='initial'
              animate='in'
              exit='out'
              variants={pageVariants}
              transition={pageTransition}
              className={` relative z-10 bg-[rgba(248,248,248,0.6)]  bg-opacity-65  `}

            >
              <div className=''>
                <div className='min-h-screen'>
                  <Outlet />
                </div>
              </div>


            </motion.div>
          </div>
        </div>

        
      </motion.div>
      <Footer />

    </div>
  )
}

export default PageContainer